import { Printer, Layers, Sparkles, Trophy, PackageOpen, Flag, Hexagon, MonitorPlay, Building2, Gift } from "lucide-react";
import { pickImage } from "./imagePool";

export const SERVICE_LIST = [
  {
    slug: "printing-solutions",
    title: "Printing Solutions",
    icon: Printer,
    image: pickImage("printing-solutions", "Printing Solutions", 0),
    short: "Offset, digital and large-format printing with calibrated colour and premium substrates.",
  },
  {
    slug: "corporate-branding",
    title: "Corporate Branding",
    icon: Sparkles,
    image: pickImage("corporate-branding", "Corporate Branding", 0),
    short: "Identity systems, brand collateral and office branding rolled out at scale.",
  },
  {
    slug: "signage-solutions",
    title: "Signage Solutions",
    icon: Building2,
    image: pickImage("signage-solutions", "Signage Solutions", 0),
    short: "Indoor, outdoor and wayfinding signage — fabricated, mounted and maintained.",
  },
  {
    slug: "exhibition-displays",
    title: "Exhibition Displays",
    icon: MonitorPlay,
    image: pickImage("exhibition-displays", "Exhibition Displays", 0),
    short: "Booth design, fabrication and on-site execution for global exhibitions.",
  },
  {
    slug: "promotional-products",
    title: "Promotional Products",
    icon: Gift,
    image: pickImage("promotional-products", "Promotional Products", 0),
    short: "Branded giveaways, employee kits and corporate merch — curated and shipped.",
  },
  {
    slug: "event-branding",
    title: "Event Branding",
    icon: Trophy,
    image: pickImage("event-branding", "Event Branding", 0),
    short: "Stage, media wall, backdrop, signage and gifting in a single coordinated package.",
  },
  {
    slug: "acrylic-fabrication",
    title: "Acrylic Fabrication",
    icon: Hexagon,
    image: pickImage("acrylic-fabrication", "Acrylic Fabrication", 0),
    short: "Laser-cut, engraved and bonded acrylic for premium retail and office spaces.",
  },
  {
    slug: "display-stands",
    title: "Display Stands",
    icon: Layers,
    image: pickImage("display-stands", "Display Stands", 0),
    short: "Counter-top, free-standing and modular display systems for retail and exhibitions.",
  },
  {
    slug: "packaging-solutions",
    title: "Packaging Solutions",
    icon: PackageOpen,
    image: pickImage("packaging-solutions", "Packaging Solutions", 0),
    short: "Branded boxes, sleeves and gift packaging — print-ready production.",
  },
  {
    slug: "flags-and-banners",
    title: "Flags and Banners",
    icon: Flag,
    image: pickImage("flags-and-banners", "Flags and Banners", 0),
    short: "Indoor flags, outdoor poles, roll-ups, flying banners and media walls.",
  },
];

export const ADVANTAGES = [
  { title: "Fully Online Platform", desc: "Browse, brief, approve and reorder — all from a single dashboard.", icon: "Globe" },
  { title: "Top-Quality Network", desc: "A vetted UAE production network with quality controls at every step.", icon: "ShieldCheck" },
  { title: "Worldwide Delivery", desc: "From Dubai to anywhere — courier handling and customs sorted.", icon: "Plane" },
  { title: "Quality + Value", desc: "Premium materials at transparent prices — no hidden overheads.", icon: "BadgeCheck" },
  // { title: "24/7 Customer Support", desc: "Project managers on chat, email and phone around the clock.", icon: "Headphones" },
  { title: "Creativity & Experience", desc: "5+ years and 500+ projects of design-led production craft.", icon: "Sparkles" },
];
